import React, { useState } from 'react';
import { Wand2, Loader2 } from 'lucide-react';

export const STARTER_QS = [
  { key: 'passion', label: 'What are you good at, or what do you love?', ph: 'e.g. I have 20 cats, I love caring for them and teaching people how to choose the right cat', type: 'text', required: true },
  { key: 'experience', label: 'Tell us your experience or story', ph: 'How long, what you have done, what people ask you about', type: 'text' },
  { key: 'audience', label: 'Who do you want to help or reach?', ph: 'e.g. first-time cat owners, busy families', type: 'text' },
  { key: 'show_up', label: 'How do you want to show up?', type: 'multi', options: ['Live video', 'Social posts', 'Teaching / classes', 'One-on-one help', 'Selling products', 'Writing / blog', 'Events', 'Podcast'] },
  { key: 'money', label: 'How would you like to make money?', type: 'multi', options: ['Services', 'Physical products', 'Digital products', 'Courses', 'Memberships', 'Donations / tips', 'Sponsorships / affiliate', 'Not sure, suggest for me'] },
  { key: 'stage', label: 'Is this a hobby, a side income, or a full business?', type: 'single', options: ['Hobby (fund my passion)', 'Side income', 'Full business', 'Nonprofit / cause'] },
  { key: 'personal', label: 'A little about you (for your bio)', ph: 'Your name, where you are based, why you started, a fun fact', type: 'text' },
  { key: 'have', label: 'What do you already have?', type: 'multi', options: ['Nothing yet (that\'s okay!)', 'Business name', 'Logo', 'Photos of me', 'Domain name', 'Social media pages', 'Customers already'] },
];

function Chips({ q, value, onChange }) {
  const arr = Array.isArray(value) ? value : value ? [value] : [];
  const toggle = (o) => {
    if (q.type === 'single') onChange(arr[0] === o ? '' : o);
    else onChange(arr.includes(o) ? arr.filter((x) => x !== o) : [...arr, o]);
  };
  return (
    <div className="flex flex-wrap gap-2">
      {q.options.map((o) => {
        const on = arr.includes(o);
        return (
          <button key={o} type="button" onClick={() => toggle(o)} data-testid={`starter-${q.key}-${o.toLowerCase().replace(/[^a-z]+/g, '-')}`}
            className={`px-3 py-1.5 rounded-full text-sm font-semibold border transition-colors ${on ? 'bg-[#F97316] text-white border-[#F97316]' : 'bg-white text-[#475569] border-[#E2E8F0] hover:border-[#F97316]'}`}>{o}</button>
        );
      })}
    </div>
  );
}

export default function ConceptStarterForm({ starter, onSave, onDesign, designing, hasConcept }) {
  const [vals, setVals] = useState(starter || {});
  const set = (k, v, persist) => { const nv = { ...vals, [k]: v }; setVals(nv); if (persist) onSave(nv); };
  return (
    <div className="space-y-4" data-testid="concept-starter-form">
      {STARTER_QS.map((q, i) => (
        <div key={q.key}>
          <label className="block text-sm font-bold text-[#0A0F1C] mb-1.5"><span className="text-[#F97316] mr-1">{i + 1}.</span>{q.label}{q.required && <span className="text-red-500"> *</span>}</label>
          {q.type === 'text' ? (
            <textarea rows={2} value={vals[q.key] || ''} placeholder={q.ph} data-testid={`starter-${q.key}`}
              onChange={(e) => set(q.key, e.target.value)} onBlur={() => onSave(vals)}
              className="w-full px-3 py-2 rounded-lg border border-[#E2E8F0] text-sm focus:border-[#F97316] outline-none resize-y bg-white" />
          ) : <Chips q={q} value={vals[q.key]} onChange={(v) => set(q.key, v, true)} />}
        </div>
      ))}
      <button type="button" disabled={designing || !(vals.passion || '').trim()} onClick={() => { onSave(vals); onDesign(); }} data-testid="concept-design-btn"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#F97316] to-[#1D4ED8] text-white font-bold shadow-lg hover:opacity-95 disabled:opacity-60">
        {designing ? <><Loader2 size={18} className="animate-spin" /> Designing your concept (about 1–2 min)…</> : <><Wand2 size={18} /> {hasConcept ? 'Redesign it for me' : 'Design it for me'}</>}
      </button>
    </div>
  );
}
